import { traffic as API } from '../../api'
import Category from '../models/Category'
import Client from '../models/Client'
import Department from '../models/Department'
import Task from '../models/Task'
import User from '../models/User'
import moment from 'moment'
import { createHolidays, getWeekLabel } from '../../calendar'

const weeks = []
let date = moment().weekday(0).subtract(1, 'week').startOf('day').hours(9).minutes(30)
for(var i=0; i<53; i++) {
  weeks.push(date.clone().add(i, 'w').valueOf())
}

const holidays = {}
createHolidays(weeks[0], weeks[weeks.length-1]).forEach(holiday => holidays[moment(holiday.date).format('YYYY-MM-DD')] = holiday)

const slots = 7
let movingTasks, movingIntId, movingPromises = []

// initial state
const state = {
  loading: false,
  cloneMode: false,
  exports: [],
  traffic: {},
  week_index: 0,
  weekdays: [],
  weeks,
}

// getters
const getters = {
  cloneMode: state => state.cloneMode,
  categories: state => {
    const categories = Category.query().orderBy('name').get()
    categories.unshift(new Category({id: null, name: '(Brak)'}))
    return categories
  },
  clients: state => Client.query().orderBy('name').get(),
  departments: state => {
    return Department.query()
                     .with('users', query => query.orderBy('sort'))
                     .where(department => {
                       const users = User.query()
                                         .where('department_id', department.id)
                                         .where('trafficable', true)
                                         .count()
                       return users > 0
                     })
                     .orderBy('name')
                     // .limit(1)
                     .get()
  },
  dayTasksByUser: state => (user, day, exclude = null) => {
    user = User.find(user.id)
    const tasks = dayTasksByUser(user, day, exclude)
    return tasks
  },
  exports: state => state.exports,
  getHoliday: state => date => holidays[moment(date).format('YYYY-MM-DD')],
  hours: state => (day = null, range = false) => {
    if(!day) day = moment().startOf('day').hours(9).minutes(30).valueOf()
    const hours = []
    for(var i = 0; i < slots + (range ? 1 : 0); i++) {
      hours.push(moment(day).add(i, 'hour').valueOf())
    }
    return hours
  },
  loading: state => state.loading,
  slots: state => slots,
  taskById: state => id => {
    return Task.find(id)
  },
  traffic: state => state.traffic,
  users: state => User.query()
                      .where('department_id', value => value > 0)
                      .where('trafficable', true)
                      .orderBy('first_name').get(),
  week_index: state => state.week_index,
  weekdays: state => state.weekdays,
  weeks: state => state.weeks,
}

// actions
const actions = {
  // newTask(context, data) {
  //   return new Promise((resolve, reject) => {
  //     Task.insert({ data }).then(result => resolve(result.tasks[0]))
  //   })
  // },
  getWeek({ commit, dispatch, state }, week) {
    return API.getWeek(week)
              .then(response => {
                commit('WEEK', {...response, week})
                const weekdays = []
                const current = state.weeks[state.week_index]
                for(var i=0; i<5; i++) {
                  const timestamp = moment(current).add(i, 'day').valueOf()
                  weekdays.push({
                    timestamp,
                    holiday: getters.getHoliday(state)(timestamp)
                  })
                }
                commit('TRAFFIC', {traffic: {}, weekdays})
              })
              .catch(failed => dispatch('failed', failed, { root: true }))
  },
  moveTasks({ dispatch }, { day, tasks }) {
    return new Promise((resolve, reject) => {
      const starts_at = moment(day)
      let { duration, empties } = getDuration(tasks, true)
      // console.log(duration, empties.slice(), tasks.slice());
      while(duration > slots && empties.length) {
        const empty = empties.pop()
        const removed = tasks.splice(empty, 1)
        if(!removed[0].isSpecial()) duration--
      }
      let foreign
      for(let i=0; i<tasks.length && !foreign; i++) {
        if(tasks[i].starts_at.substr(0, 10) != starts_at.format('YYYY-MM-DD')) {
          foreign = tasks[i]
        }
      }
      if(foreign) duration -= foreign.duration
      const available = slots - duration
      // console.log('available', available, 'foreign', foreign ? foreign.toString() : null)
      // console.log(duration, empties.slice(), tasks.slice());
      const result = []
      let slot = 0
      tasks.forEach(item => {
        let d = item.duration
        if(!item.isEmpty()) {
          let starts_at = moment(day).add(slot, 'hour')
          let data = {
            starts_at: starts_at.format('YYYY-MM-DD HH:mm:ss'),
            ends_at: starts_at.clone().add(d, 'hour').format('YYYY-MM-DD HH:mm:ss'),
          }
          const isForeign = item.starts_at.substr(0, 10) != starts_at.format('YYYY-MM-DD')
          if(item.starts_at == data.starts_at && item.ends_at == data.ends_at) data = null
          else {
            let before = d
            // d = Math.min(d, Math.max(1, slots - slot, slots - duration))
            d = Math.min(d, Math.max(1, slots - slot), (isForeign ? slots - duration : slots))
            data.ends_at = moment(day).add(slot, 'hour').add(d, 'hour').format('YYYY-MM-DD HH:mm:ss')
            data.id = item.id
            Task.update(data)
          }
          if(!item.id) {
            const tmp = item.toJSON()
            for(var k in tmp) {
              if(data[k] || tmp[k] == null || tmp[k] == undefined || k == 'owner_id') continue
              data[k] = tmp[k]
            }
          }
          if(data) result.push(data)
        }
        slot += d
      })
      movingTasks = (movingTasks || []).concat(result)
      if(movingTasks.length) {
        movingPromises.push({ resolve, reject })
        clearTimeout(movingIntId)
        // console.log('movingTasks', JSON.stringify(movingTasks))
        movingIntId = setTimeout(function() {
          API.updateTasks(movingTasks)
            .then(response => {
              movingTasks = []
              // console.log('here', response)
              // commit('TRAFFIC', {traffic: {}})
              let promise
              while(promise = movingPromises.pop()) {
                promise.resolve(response)
              }
            })
            .catch(failed => {
              movingTasks = []
              if(failed.errors && failed.errors.duration && failed.errors.duration.length) failed.message = failed.errors.duration[0]
              dispatch('failed', failed, { root: true })
              let promise
              while(promise = movingPromises.pop()) {
                promise.reject(failed)
              }
            })
        }, 0)
      }
    })
  },
  setCloneMode({ commit, state }, mode) {
    if(mode != state.cloneMode) commit('CLONE_MODE', mode)
  },
  // refreshUserDayTasks({ commit, state }, { user, day }) {
  //   // const traffic = { ...state.traffic }
  //   // traffic[user.id][day] = dayTasksByUser(user, day)
  //   // const weekdays = state.weekdays
  //   const tasks = dayTasksByUser(user, day)
  //   commit('USERDAYTASKS', { user, day, tasks })
  //   // commit('TRAFFIC', {traffic, weekdays})
  // },
  unshiftWeek({ commit }) {
    commit('UNSHIFT_WEEK')
  },
  updateTasks({ dispatch, commit }, tasks) {
    return new Promise((resolve, reject) => {
      API.updateTasks(tasks)
        .then(response => {
          resolve(response)
          // console.log('here', response)
          // commit('TRAFFIC', {traffic: {}})
        })
        .catch(failed => {
          if(failed.errors && failed.errors.duration && failed.errors.duration.length) failed.message = failed.errors.duration[0]
          dispatch('failed', failed, { root: true })
          reject(failed)
        })
      })
  },
  getExports({ dispatch, commit }) {
    return API.getExports()
              .then(response => {
                commit('EXPORTS', response)
              })
              .catch(failed => dispatch('failed', failed, { root: true }))
  },
  download({ dispatch, commit }, year) {
    commit('LOADING', true)
    return API.download(year)
              .then(response => commit('LOADING', false))
              .catch(failed => {
                commit('LOADING', false)
                dispatch('failed', failed, { root: true })
              })
  },
}

// mutations
const mutations = {
  CLONE_MODE: (state, mode) => state.cloneMode = mode,
  WEEK: (state, { week, entities }) => {
    const weeks = getters.weeks(state)
    for(var i = 0; i < weeks.length; i++)
    {
      if(week == getWeekLabel(weeks[i])) {
        state.week_index = i
        break
      }
    }
  },
  TRAFFIC: (state, { traffic, weekdays }) => {
    state.traffic = traffic
    if(weekdays) state.weekdays = weekdays
  },
  UNSHIFT_WEEK: (state) => {
    let date = moment(state.weeks[0]).weekday(0).subtract(1, 'week').startOf('day').hours(9).minutes(30)
    state.weeks.unshift(date.valueOf())
    state.week_index++
  },
  // USERDAYTASKS: (state, { user, day, tasks }) => {
  //   const traffic = { ...state.traffic }
  //   traffic[user.id][day] = tasks
  //   state.traffic = traffic
  // },
  EXPORTS: (state, data) => state.exports = data,
  LOADING: (state, loading) => state.loading = loading,
}

function dayTasksByUser(user, day, exclude = null) {
  // if(user.id == 4) console.log(moment(day).format('YYYY-MM-DD'), exclude);
  let tasks = user.getTasksByDay(day)
  // if(exclude) tasks = tasks.filter(task => task.id != exclude.id)
  const hours = getters.hours(state)(day)
  let shift = 0
  let i = 0
  const result = []
  const empties = []
  for(let i = 0; i < hours.length; i++) {
    let hour = moment(hours[i]).format('YYYY-MM-DD HH:mm:ss')
    let exists = false
    for(let j = 0; j < tasks.length; j++) {
      const task = tasks[j]
      exists = hour >= task.starts_at
      if(exists) {
        result.push(task)
        tasks.shift()
        i += task.duration - 1
        break
      }
    }
    if(!exists) {
      const empty = new Task({
        empty: true,
        assigned_to_id: user.id,
        starts_at: hour,
        ends_at: moment(hour).add(1, 'hour').format('YYYY-MM-DD HH:mm:ss')
      })
      empties.push(empty)
      result.push(empty)
    }
  }
  if(user.creative && empties.length && moment(day).day() == 1 && moment("2019-05-20 00:00:00").diff(moment(day).startOf('day'), 'day') <= 0) {
    empties[0].creative = true
  }
  if(user.supervisor && empties.length) {
    empties[empties.length-1].supervisor = true
  }
  if(user.administration && empties.length) {
    empties[empties.length-1].administration = true
  }
  // day = moment(day).format('YYYY-MM-DD')
  // if(user.id == 4 && day == '2019-05-27') {
  //   let tasks = 0
  //   result.forEach(t => {
  //     if(t.id) tasks++
  //   })
  //   // console.log('dayTasksByUser', day, tasks, result.length)
  // }
  return result
}

function getDuration(tasks, all = false) {
  const debug = false
  let duration = 0
  const empties = []
  if(debug) console.log('---- getDuration ----', all);
  for(let i = 0; i < tasks.length; i++) {
    const item = tasks[i]
    if(debug) console.log(item.id, item.duration);
    if(item.isEmpty()) empties.push(i)
    if(all || !item.isEmpty()) duration += item.duration
  }
  if(debug) console.log('---------------------');
  return { duration, empties }
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
